import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-checkmark-icon/jb-checkmark-icon.css.ts
var jb_checkmark_icon_css_default = i``;

export {
  jb_checkmark_icon_css_default
};
